import styled from 'styled-components';

import { SkeletonCardPreset } from '@xing-com/skeleton';
import { xdlColorBackground } from '@xing-com/tokens';

import { JobsSectionCarousel } from './jobs-section-carousel';

export const SimilarJobsSkeleton: React.FC = () => {
  return (
    <JobsSectionCarousel useDesktopVersion>
      {Array.from({ length: 5 }).map((_, index) => (
        <SkeletonCard key={index} variant="profile" />
      ))}
    </JobsSectionCarousel>
  );
};

const SkeletonCard = styled(SkeletonCardPreset)`
  background-color: ${xdlColorBackground};
`;
